// [AI GENERATED CODE]
// Centralized cache management for all API responses

import { getCachedValue, setCacheWithTimeout, removeValueForKey } from './cache-helper';

// Cache duration constants
const CACHE_DURATION = {
  USER_SETTINGS: 24 * 60 * 60 * 1000, // 24 hrs
  // Add more cache durations for other APIs as needed
  // PROFILE: 5 * 60 * 1000, // 5 minutes
  // COURSE_PLAYLIST: 15 * 60 * 1000, // 15 minutes
};

// ============== USER SETTINGS CACHE ==============

// [AI GENERATED CODE]
// Helper function to generate cache key for user settings with optional prefix
function getUserSettingsCacheKey(prefix = '') {
  try {
    const studentId = JSON.parse(localStorage.getItem('user_student'))?.id;
    if (!studentId) return null;
    
    const baseKey = `userSettings_${studentId}`;
    return prefix ? `${prefix}.${baseKey}` : baseKey;
  } catch (error) {
    console.error('Error getting student ID for user settings cache key:', error);
    return null;
  }
}

// [AI GENERATED CODE]
// Get user settings from cache
export async function getUserSettingsFromCache() {
  return await getCachedValue(getUserSettingsCacheKey());
}

// [AI GENERATED CODE]
// Cache user settings data
export function cacheUserSettings(data) {
  setCacheWithTimeout(
    getUserSettingsCacheKey(),
    data,
    CACHE_DURATION.USER_SETTINGS
  );
}

// [AI GENERATED CODE]
// Invalidate cached user settings for the current student
export function invalidateUserSettingsCache() {
  const cacheKey = getUserSettingsCacheKey();
  const flutterCacheKey = getUserSettingsCacheKey('flutter');
  if(cacheKey) removeValueForKey(cacheKey);
  if (flutterCacheKey) removeValueForKey(flutterCacheKey);
}

// ============== ADD MORE API CACHES BELOW ==============

// Example for future APIs:
//
// ============== PROFILE CACHE ==============
// export function getProfileCacheKey() { ... }
// export async function getProfileFromCache() { ... }
// export function cacheProfileData(data) { ... }
// export function invalidateProfileCache() { ... }
//
// ============== COURSE PLAYLIST CACHE ==============
// export function getCoursePlaylistCacheKey() { ... }
// export async function getCoursePlaylistFromCache() { ... }
// export function cacheCoursePlaylistData(data) { ... }
// export function invalidateCoursePlaylistCache() { ... }